var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackgroundCover = function SvgBackgroundCover(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 120,
    fill: "none",
    viewBox: "0 0 670 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.427,
    cy: -57.378,
    r: 138.72,
    fill: "#fff",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.122,
    cy: 305.427,
    r: 320.122,
    fill: "#fff",
    opacity: 0.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundCover);
export default ForwardRef;